import React from 'react';
import Layout from "../layout";
import NotificationsList from '../../components/notifications/list';

const NotificationsScreen = () => {

  return (
    <Layout controllerName='Notificações' breadcrumb='Dashbord / Notificações'>
      <NotificationsList />
    </Layout>
  )

}

export default NotificationsScreen;

